class Queue {
  constructor () {
    this.queue = []
    this.activeUploads = new Map()
  }

  add (item) {
    this.queue.push(item)
  }

  process (config) {
    const { maxConcurrency, handler, callback } = config

    if (this.queue.length && this.activeUploads.size < maxConcurrency) { // only process a item if the queue is not empty and concurrency has not reached its limit
      const itemToUpload = this.queue.shift()

      // Armazena o item em processamento
      const uploadId = Date.now() + '-' + Math.random().toString(36).substr(2, 9)
      this.activeUploads.set(uploadId, itemToUpload)

      // upload
      handler(itemToUpload, this.queue)
        .then((response) => {
          this.activeUploads.delete(uploadId)

          this.process(config) // start processing the next item since one of the queue has already finished
          callback(response, itemToUpload)
        })
        .catch((error) => {
          console.error('Erro ao processar o upload:', error)
          this.activeUploads.delete(uploadId)

          // Inicia o processamento do próximo item mesmo em caso de erro
          this.process(config)

          // Rejeita a promessa do item
          if (itemToUpload.reject) {
            itemToUpload.reject(itemToUpload)
          }
        })

      this.process(config) // call this to start processing the next item until concurrency reaches its limit
    }
  }

  clear () {
    this.queue.length = 0

    // Cancela todos os uploads ativos
    this.activeUploads.forEach((item) => {
      if (item.file && item.file.abortUpload) {
        item.file.abortUpload()
      }

      if (item.reject) {
        item.reject(new Error('Upload cancelado'))
      }
    })

    this.activeUploads.clear()
  }

  getQueueLength () {
    return this.queue.length
  }

  getActiveUploadsCount () {
    return this.filesUploading
  }
}

/* @ngInject */
function uploadQueueService () {
  const service = {
    createQueue
  }
  return service

  function createQueue () {
    return new Queue()
  }
}

export { uploadQueueService }
